module.exports = __webpack_public_path__ + "static/img/image@2x (3).e79b024c.png";